module.exports = __webpack_public_path__ + "img/intro-bg.84789ee6.jpg";